/**
 * Tournaments configuration for different brands
 */
import { config } from '@/config.ts';

export interface TournamentConfig {
	spreadsheetId: string;
	apiKey: string;
	sheetId: string;
}

export const TOURNAMENTS_CONFIG: Record<string, TournamentConfig> = {
	// Default/PM configuration
	pm: {
		spreadsheetId: '17zSGDS1555cZPEJVTDVVj85qCtVdgFd4dmpmH5jAjG4',
		apiKey: 'AIzaSyCJ-OwS_CHE1aIcz4osT4bPa1Q6Mc2AolE',
		sheetId: 'Лист1'
	},
	
	// Nomad brand configuration  
	nomad: {
		spreadsheetId: '17zSGDS1555cZPEJVTDVVj85qCtVdgFd4dmpmH5jAjG4', // TODO: Replace with Nomad's ID
		apiKey: 'AIzaSyCJ-OwS_CHE1aIcz4osT4bPa1Q6Mc2AolE', // TODO: Replace with Nomad's key
		sheetId: 'Лист1'
	},
	
	// Johnny brand configuration
	johnny: {
		spreadsheetId: '17zSGDS1555cZPEJVTDVVj85qCtVdgFd4dmpmH5jAjG4', // TODO: Replace with Johnny's ID
		apiKey: 'AIzaSyCJ-OwS_CHE1aIcz4osT4bPa1Q6Mc2AolE', // TODO: Replace with Johnny's key
		sheetId: 'Лист1'
	},
	
	// xpass brand configuration
	xpass: {
		spreadsheetId: '17zSGDS1555cZPEJVTDVVj85qCtVdgFd4dmpmH5jAjG4', // TODO: Replace with xpass's ID
		apiKey: 'AIzaSyCJ-OwS_CHE1aIcz4osT4bPa1Q6Mc2AolE', // TODO: Replace with xpass's key
		sheetId: 'Лист1'
	},
	
	// Rockets brand configuration
	rockets: {
		spreadsheetId: '17zSGDS1555cZPEJVTDVVj85qCtVdgFd4dmpmH5jAjG4', // TODO: Replace with Rockets' ID
		apiKey: 'AIzaSyCJ-OwS_CHE1aIcz4osT4bPa1Q6Mc2AolE', // TODO: Replace with Rockets' key
		sheetId: 'Лист1'
	}
};

/**
 * Get tournament configuration for current brand
 */
export const getTournamentConfig = (): TournamentConfig => {
	const brand = config.BRAND || 'default';
	return TOURNAMENTS_CONFIG[brand] || TOURNAMENTS_CONFIG.default;
};

/**
 * Build Google Sheets API URL for tournaments
 */
export const buildTournamentsApiUrl = (): string => {
	const config = getTournamentConfig();
	return `https://sheets.googleapis.com/v4/spreadsheets/${config.spreadsheetId}/values/${config.sheetId}?alt=json&key=${config.apiKey}`;
}; 